/*
 * @Author: 李才人
 * @Date: 2021-08-05 11:36:40
 * @LastEditors: 李才人
 * @LastEditTime: 2021-08-05 12:00:47
 * @FilePath: \m_saas_business_admin\src\store\modules\app.ts
 * @Description:
 */
// import { CustomRoute } from "@router/types";
// import { setSession, getSession } from "@utils/localStorageUtil";
// import { ls_sideMenus } from "@/dataBase/localStorageKeys";
// const sideMenus = getSession(ls_sideMenus);
import { getModule, Module, VuexModule } from "vuex-module-decorators";
import instance from "../instance";
@Module({
  name: "APP",
  dynamic: true,
  namespaced: true,
  store: instance,
})
export class APP extends VuexModule {}
export default getModule(APP);
